import React from "react";

function Navbar({ onHomeClick, onEventsClick, onPrayerClick, onAboutClick }) {
  return (
    <nav style={styles.nav}>
      {/* Logo Section */}
      <div style={styles.logoContainer}>
        <img src="/logo.png" alt="Mosque Logo" style={styles.logo} />
      </div>

      {/* Navigation Links */}
      <div style={styles.linksContainer}>
        <span onClick={onHomeClick} style={styles.link}>Home</span>
        <span onClick={onEventsClick} style={styles.link}>Events</span>
        <span onClick={onPrayerClick} style={styles.link}>Prayer Times</span>
        <span onClick={onAboutClick} style={styles.link}>Contact</span>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem 2rem',
    backgroundColor: '#ffffffff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    position: 'sticky', // keep navbar fixed when scrolling
    top: 0,
    zIndex: 1000,
  },
  logoContainer: {
    marginBottom: '1rem',
    textAlign: 'center',
  },
  logo: {
    height: '150px',
    width: 'auto',
    maxWidth: '200px',
  },
  linksContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
    flexWrap: 'wrap',
  },
  link: {
    textDecoration: 'none',
    color: '#333',
    fontFamily: "'Georgia', serif",
    fontSize: '1.1rem',
    fontWeight: '500',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    cursor: 'pointer',
  },
};

export default Navbar;
